var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMargin06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 161,
    viewBox: "0 0 154 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M97.6509 105.771H19.4609V21.7207H140.121V105.771H112.531",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M140.119 105.77L151.579 158.83H7.35938L19.4594 105.77",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M93.6391 137.15L96.3191 149.55H62.6191L65.4491 137.15H93.6391Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M97.5996 93.25L97.7596 134.67L107.61 126.42L116.88 146.27L125.27 142.15L116.35 122.06L129.29 120.13L97.5996 93.25Z",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.2601 129.1C46.0001 129.1 46.0001 124.85 43.2601 124.85C40.5201 124.85 40.5201 129.1 43.2601 129.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M113.44 13.25C116.18 13.25 116.18 9 113.44 9C110.7 9 110.7 13.25 113.44 13.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M38.4202 93.4492C41.1602 93.4492 41.1602 89.1992 38.4202 89.1992C35.6802 89.1992 35.6802 93.4492 38.4202 93.4492Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M151.58 82.8906C154.32 82.8906 154.32 78.6406 151.58 78.6406C148.84 78.6406 148.84 82.8906 151.58 82.8906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M97.6002 12.72C100.56 12.72 102.96 10.3202 102.96 7.35999C102.96 4.39974 100.56 2 97.6002 2C94.64 2 92.2402 4.39974 92.2402 7.35999C92.2402 10.3202 94.64 12.72 97.6002 12.72Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.36 107.15C10.3202 107.15 12.72 104.75 12.72 101.79C12.72 98.8294 10.3202 96.4297 7.36 96.4297C4.39975 96.4297 2 98.8294 2 101.79C2 104.75 4.39975 107.15 7.36 107.15Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M26.3008 83.9206V28.6406H81.5908",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M79.4707 44.3203V71.7603",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M95.0199 67.6211L79.4699 83.1711L63.9199 67.6211",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMargin06);
export default __webpack_public_path__ + "static/media/icon_margin_06.40c233c0d4926f62448dc3985d05c59c.svg";
export { ForwardRef as ReactComponent };